module.exports = __webpack_public_path__ + "img/300.1b334c70.png";